<template>
  <VDialog
    :model-value="isDialogVisible"   
    width="900"
    @update:model-value="updateDialogVisible"
  >
    <DialogCloseBtn @click="updateDialogVisible(false)" />

    <VCard>
      <template #title>
        <span class="font-weight-bold text-h4">
          Lokasi Hotspot Banjir ({{ stateName }}) ({{ totalBilanganBanjir }})
        </span>
      </template>

      <div style="max-height: 500px; overflow-y: auto; padding: 20px;">
        <VTable
          class="text-no-wrap"
          style="border-collapse: collapse; width: 100%;"
        >
          <thead>
            <tr class="bg-gray-600 border-b-2 border-gray-300">
              <th
                class="text-center py-2 px-4"
                style="color: white !important; font-size: 1rem; width: 10%; border: 1px solid black;"
              >
                Bil.
              </th>
              <th
                class="text-center py-2 px-4"
                style="color: white !important; font-size: 1rem; width: 70%; border: 1px solid black;"
              >
                PBT
              </th>
              <th
                class="text-center py-2 px-4"
                style="color: white !important; font-size: 1rem; width: 20%; border: 1px solid black;"
              >
                Bil. Lokasi Banjir Kilat
              </th>
            </tr>
          </thead>

          <tbody v-if="pbtList['pbts']">
            <tr
              v-for="(item, index) in pbtList['pbts']"
              :key="item.id"
              :class="index % 2 === 0 ? 'bg-white' : 'bg-white'"
              style="border: 1px solid black;"
            >
              <td
                class="text-center py-2 px-4"
                style="border: 1px solid black;"
              >
                {{ index + 1 }}
              </td>
              <td
                class="py-2 px-4"
                style="border: 1px solid black;"
              >
                {{ item.council }}
              </td>
              <td
                class="text-center py-2 px-4"
                style="border: 1px solid black;"
              >
                {{ item.bilangan_banjir }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td
                colspan="3"
                class="text-center py-2 px-4"
                style="border: 1px solid black;"
              >
                No data available for this state.
              </td>
            </tr>
          </tbody>
        </VTable>
      </div>
    </VCard>
  </VDialog>
</template>

<script setup>
import { computed, defineProps } from 'vue'

const props = defineProps({
  stateName: {
    type: String,
    required: true,
  },
  isDialogVisible: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['update:isDialogVisible'])

const pbtList = ref([])

// Calculate the total number of "Bil. Lokasi Banjir Kilat"
const totalBilanganBanjir = computed(() =>
  pbtList.value['pbts']
    ? pbtList.value['pbts'].reduce((sum, item) => sum + (item.bilangan_banjir || 0), 0)
    : 0,
)

// Reactive computed for watching dialog visibility
const dialogVisible = computed(() => props.isDialogVisible)

function updateDialogVisible(value) {
  emit('update:isDialogVisible', value)
}

async function fetchPBTData() {
  const response = await fetch(
    `https://jktgateway.kpkt.gov.my/api/kejuruteraan-kesihatan-umum/senarai-hotspot-banjir-by-state?state=${props.stateName}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )

  if (!response) {
    console.error('Network response was not ok')
  }

  pbtList.value = await response.json()
  console.log('PBT List:', pbtList.value)
}

watch(dialogVisible, async newVal => {
  if (newVal) {
    console.log('Dialog became visible. Fetching PBT data...')
    await fetchPBTData()
  }
})
</script>
